<h4>{{documentTypeLabel}}</h4>
<table mat-table [dataSource]="datalistsource" >

  <ng-container *ngFor="let column of displayedColumns">

    <ng-container matColumnDef="{{column}}">
      <th mat-header-cell
          class="pl-2 pr-2 text-capitalize" *matHeaderCellDef>{{getColumnLabel(column)}}</th>
      <td mat-cell *matCellDef="let element">
        <div class="ms-2 me-2">
          {{element[column]}}
        </div>
      </td>
    </ng-container>

  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
